export default {"src":"/_next/static/media/CollectCoin.abaa6595.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};